import { jsx as r } from "react/jsx-runtime";
import d from "./index.es740.js";
import { CellAdditionalInfoWrapper as p } from "./index.es731.js";
import { MiniBarChart as C } from "./index.es149.js";
const v = ({
  testId: i,
  bins: o,
  gridDensity: t,
  additionalInfo: n,
  labelAlignment: e,
  labelPrefix: l,
  labelSuffix: a,
  hideLabels: m,
  labelFixedWidth: s
}) => {
  const c = t === "comfort" ? 4 : 2, f = o.slice(0, c);
  return /* @__PURE__ */ r("div", { "data-testid": `${i}-cell`, className: d.root, children: /* @__PURE__ */ r(p, { ...n, children: /* @__PURE__ */ r(
    C,
    {
      testId: i,
      bins: f,
      labelAlignment: e,
      labelPrefix: l,
      labelSuffix: a,
      hideLabels: m,
      labelFixedWidth: s,
      fitContainer: !1
    }
  ) }) });
};
export {
  v as MiniBarChartCell
};
//# sourceMappingURL=index.es575.js.map
